/** Bump when shipping meaningful changes during the creation phase. */
export const APP_VERSION = "0.1.0";
export const RELEASE_STAGE = "alpha";
export const LAST_UPDATED = "2026-05-17";
